import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNote1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="note-1"><path fillRule="evenodd" clipRule="evenodd" d="M3 4.75C3 3.7835 3.7835 3 4.75 3H19.25C20.2165 3 21 3.7835 21 4.75V14.5H16.25C15.2835 14.5 14.5 15.2835 14.5 16.25V21H4.75C3.7835 21 3 20.2165 3 19.25V4.75Z" fill="currentColor"/><path d="M16 20.9503C16.3091 20.875 16.5945 20.7161 16.8232 20.4874L20.4874 16.8232C20.7161 16.5945 20.875 16.3091 20.9503 16H16.25C16.1119 16 16 16.1119 16 16.25V20.9503Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNote1;
